export default "__VITE_ASSET__Cjecp_vk__"